import React from "react";
import WaitingPopup from "./WaitingPopup";
import ConfirmPopup from "./ConfirmPopup";
import ToastPopup from "./ToastPopup";
import SlidePopup from "./SlidePopup";
import UserManualPopup from "./UserManualPopup";

// 모든 공통 UI Manager를 한 곳에서 내보내기
export { WaitingManager } from "./WaitingPopup/WaitingManager";
export { ConfirmManager } from "./ConfirmPopup/ConfirmManager";
export { ToastManager } from "./ToastPopup/ToastManager";
export { SlideManager } from "./SlidePopup/SlideManager";
export { UserManualManager } from "./UserManualPopup/UserManualManager";

const CommonUI: React.FC = () => {
  return (
    <>
      <WaitingPopup />
      <ConfirmPopup />
      <ToastPopup />
      <SlidePopup />
      <UserManualPopup />
    </>
  );
};

export default CommonUI;
